import React from "react";
import { Outlet } from "react-router-dom";
import { AppSidebarUser } from "../../components/appSidebarUser";
import { SidebarProvider } from "../../components/ui/sidebar";
import { useLanguage } from "../../context/LanguageContext";
import UserHeader from "./UserHeader";
import Footer from "../../components/Footer";

export default function UserRoot() {
  const { language } = useLanguage();

  return (
    <SidebarProvider>
      {language !== "ar" && <AppSidebarUser />}
      <main className="w-full flex flex-col">
        <UserHeader />
        <div className="p-5 flex-1">
          <Outlet />
        </div>
        <Footer />
      </main>
      {language === "ar" && <AppSidebarUser />}
    </SidebarProvider>
  );
}
